<template>
  <div
    :class="['status-badge', 'status-' + statusClass, 'status-badge-' + type]"
  >
    <span>{{ statusText }}</span>
  </div>
</template>

<script>
export default {
  name: "StatusBadge",
  props: {
    statusClass: {
      type: String,
      required: true,
    },
    statusText: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "default",
      validator: (value) => ["default", "large"].includes(value),
    },
  },
  methods: {},
};
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-weight: 600;
  border: 1px solid;
}

.status-badge-default {
  padding: 2px 10px;
  font-size: 12px;
}

.status-badge-large {
  padding: 6px 12px;
  font-size: 14px;
}

.status-yellow {
  background-color: #fffaea;
  border-color: #ffcf44;
  color: #bb4d00;
}

.status-green {
  background-color: #f0fdf4;
  border-color: #b9f8cf;
  color: #008236;
}

.status-blue {
  background-color: #f1f6fe;
  border-color: #81bcf8;
  color: #0953a8;
}

.status-red {
  background-color: #fdf3f3;
  border-color: #f0b1b2;
  color: #be3846;
}

.status-black {
  background-color: #f5f5f5;
  border-color: #d6d6d6;
  color: #000000;
}

.status-orange {
  background-color: #fff7ed;
  border-color: #ffd6a8;
  color: #ca3500;
}

.status-violet {
  background-color: #eef2ff;
  border-color: #c7d2fe;
  color: #4338ca;
}

.status-purple {
  background-color: #f5f3ff;
  border-color: #ddd6fe;
  color: #6d28d9;
}
</style>


// WEBPACK FOOTER //
// src/components/RentAdjustment/CustomComponent/StatusBadge.vue